import React, { useCallback, useState } from 'react';
import { Tab, Tabs, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  content: {
    marginTop: '1rem',
  },
  tabs: {
    minHeight: '2rem',
  },
  tab: {
    padding: 0,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    color: 'inherit',
    '&:hover': {
      color: palette.filterChip.hover,
    },
    outline: 'unset',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'unset',
    minHeight: '2rem',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },
  selected: {
    color: palette.filterChip.active,
    fontWeight: 600,
  },
  indicator: {
    backgroundColor: palette.filterChip.active,
  },
}), { name: 'TabsForm' });

interface ItemTab {
  title: string;
  content: React.ReactNode;
}

type Props = {
  tabs: ItemTab[];
};

const TabsForm = ({ tabs }:Props) => {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleTabChange = useCallback((event, newValue) => setValue(newValue), [
    setValue,
  ]);

  return (
    <>
      <Tabs
        value={value}
        onChange={handleTabChange}
        className={classes.tabs}
        classes={{
          indicator: classes.indicator,
        }}
      >
        {tabs.map((item, key) => (
          <Tab
            tabIndex={-1}
            classes={{ root: classes.tab, selected: classes.selected }}
            label={item.title}
            key={key}
          />
        ))}
      </Tabs>
      <div className={classes.content} key={value}>
        {tabs[value].content}
      </div>
    </>
  );
};

export default TabsForm;
